import AddressModel from "./address";
import { config } from "../utils/config";
import { Address } from "../enums/checkoutShipping";
import shippingUtils from '../utils/shipping';

export const getRegionWiseAddressList = () => {
    const regionWiseCountryList = config('regionWiseCountryList') ?? [];
    if (config('isNASite'))
        return [config('regionCode')?.toLowerCase()];

    let arr: Array<any> = [];
    let regions : Array<any> =[];
    for (let regionList of regionWiseCountryList) {
        for (let list of regionList.list) {
            if (list.countryCode === config('regionCode')?.toLowerCase()) {
                regions = regionList.list;
                break;
            }
        }
        if (regions.length > 0)
            break;
    }
    for (let country of regions) {
        arr.push((country.countryCode).toLowerCase());
    }
    return arr;
}
export default class Customer {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    isEmailVerified: string;
    customerNumber: string;
    oracleCustomerNumber: string;
    customerStatus: string;
    addresses: Array<AddressModel>;
    billingAddressIds: Array<string>;
    shippingAddressIds: Array<string>;
    shippingAddresses: Array< AddressModel>;
    billingAddresses: Array< AddressModel>;
    defaultBillingAddressId: string;
    defaultShippingAddressId: string;
    vatId ?: string;
    locale: string;
    version: number;
    defaultShippingAddressIdMyAccount: string;
    defaultBillingAddressIdMyAccount: string;

    constructor(customer: any = {}, cart : any  = {}) {
        const commonShippingAddressCountryList = getRegionWiseAddressList();
        let isDefaultShippingPresent = false;
        let isDefaultBillingPresent = false;
        this.id = customer.id;
        this.firstName = customer.firstName;
        this.lastName = customer.lastName;
        this.email = customer.email;
        this.isEmailVerified = customer.isEmailVerified;
        this.customerNumber = customer.customerNumber;
        this.oracleCustomerNumber = customer.custom?.fields?.oracleCustomerNumber;
        this.customerStatus = customer.custom?.fields?.customerStatus;
        this.vatId = customer.vatId || '';
        this.addresses = customer.addresses?.map((item: any) => new AddressModel(item)).reverse();
        this.billingAddressIds = customer.billingAddressIds;
        this.shippingAddressIds = customer.shippingAddressIds;
        this.shippingAddresses = this.addresses?.filter(address => customer.shippingAddressIds?.includes(address.id) && (commonShippingAddressCountryList.includes(address.country.toLowerCase())));
        this.billingAddresses = this.addresses?.filter(address => customer.billingAddressIds?.includes(address.id) && address.country?.toLowerCase() === config('regionCode')?.toLowerCase());
        this.defaultShippingAddressId = customer.defaultShippingAddressId;
        this.defaultBillingAddressId = customer.defaultBillingAddressId;
        this.defaultShippingAddressIdMyAccount = customer.defaultShippingAddressId;
        this.defaultBillingAddressIdMyAccount = customer.defaultBillingAddressId;
        this.locale = customer.locale;
        this.version = customer.version;
        this.shippingAddresses = this.shippingAddresses && JSON.parse(JSON.stringify(this.shippingAddresses));
        this.shippingAddresses?.forEach((address)=> {
            if(address.id === this.defaultShippingAddressId){
                address.isDefaultAddress = true;
                isDefaultShippingPresent = true;
            }
            const streetNameText = address.streetName?.toLowerCase() || '';
            const additionalStreetInfo = address.additionalStreetInfo?.toLowerCase() || ''; 
            if (shippingUtils.isPoBoxText(streetNameText) || shippingUtils.isPoBoxText(additionalStreetInfo)) {
                address.isPOBoxAddress = true;
            }
        });
        if(this.shippingAddresses?.length && !isDefaultShippingPresent) {
            this.shippingAddresses[0].isDefaultAddress = true;
            if(this.shippingAddresses[0].id) {
                this.defaultShippingAddressId = this.shippingAddresses[0].id
            }
        }
        this.billingAddresses = this.billingAddresses && JSON.parse(JSON.stringify( this.billingAddresses));
        this.billingAddresses?.forEach((address)=> {
            address.type = Address.BILLING;
            if(address.id === this.defaultBillingAddressId){
                address.isDefaultAddress = true;
                isDefaultBillingPresent = true;
            }
        });
        if(this.billingAddresses?.length && !isDefaultBillingPresent) {
            this.billingAddresses[0].isDefaultAddress = true;
            if(this.billingAddresses[0].id) {
                this.defaultBillingAddressId = this.billingAddresses[0].id
            }
        }
    }

    public setDefaultShipAndBillFromCart(cart, updateShippingFromCart = true, updateBillingFromCart = true){
        const setDefaultAddress = (addresses, id) => {
            let addressFound = false;
            addresses?.forEach((address)=> {
                address.isDefaultAddress = false;
                if(address.id === id){
                    addressFound = true;
                    address.isDefaultAddress = true;
                }
            });
            return addressFound;
        }
        if(updateShippingFromCart && cart?.shippingAddress?.id) {
            if(setDefaultAddress(this.shippingAddresses, cart.shippingAddress.id)) {
                this.defaultShippingAddressId = cart.shippingAddress.id;
            }
        }
        if(updateBillingFromCart && cart?.billingAddress?.id) {
            if(setDefaultAddress(this.billingAddresses, cart.billingAddress.id)) {
                this.defaultBillingAddressId = cart.billingAddress.id;
            };
        }
    }
}
